
  import Sticker from "@/components/sticker.vue";
  import IntioWord from "@/components/intio-word.vue";

  export default {
    name: "Welcome",
    components: {
      Sticker,
      IntioWord,
    }
  };
